import React from 'react';
import classNames from 'classnames';
import { Section } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/fiverr_context';
import { clearFiltersUrl } from '../../../../service/clientNavigation';
import ErrorImage from './images/no-results-couch.png';

import './index.scss';

const NoResults = () => (
    <Section className={classNames('error-page', 'no-results')}>
        <h2>
            <I18n k={'search_perseus.error_page.no_results.title'}/>
        </h2>
        <a className="clear-filters" href={clearFiltersUrl()}>
            <I18n k={'search_perseus.error_page.no_results.clear_filters'}/>
        </a>
        <div className="error-image">
            <img src={ErrorImage} alt="empty result image"/>
            <small><I18n k={'search_perseus.error_page.made_on_fiverr'} parseMarkup/> <b>ellacohenillu</b></small>
        </div>
    </Section>
);

export default NoResults;
